<template>
  <div class="main-business-composition">
    <RkSwitch v-model="activedTab" :options="options" class="rk-switch" />
    <VueEcharts :option="option" />
    <RkTable class="business-table" :data="segmentData" :show-footer="false" :header-split-line="false">
      <RkTableColumn prop="name" label="名称" align="left">
        <template #header>{{
          $t('$x年', {
            x: segmentData[0]?.reportDate?.slice(0, 4)
          })
        }}</template>
        <template slot-scope="{ row, index }">
          <div class="legend-item">
            <span class="legend-icon" :style="{ background: getColor(index) }"></span>
            <span class="legend-name one-line">{{ row.name }}</span>
          </div>
        </template>
      </RkTableColumn>
      <RkTableColumn prop="operatingIncome" :width="`${postcssPatch(100)}`">
        <template #header>
          {{ $t('收入') + (currency ? currency : '') }}
        </template>
        <template slot-scope="{ row }">{{ $digitjs(row.operatingIncome).convert() }}</template>
      </RkTableColumn>
    </RkTable>
  </div>
</template>

<script>
import RkSwitch from '@/components/common/RkSwitch.vue'
import VueEcharts from '@/components/common/VueEcharts.vue'
import { colour } from '@/utils/constant.js'
import { postcssPatch } from '@/utils/postcssPatch'

export default {
  components: { RkSwitch, VueEcharts },
  data() {
    return {
      activedTab: 'B',
      segmentData: []
    }
  },
  computed: {
    currency() {
      const c = this.segmentData[0]?.currency ?? ''

      return c ? `(${c})` : ''
    },
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    option() {
      return {
        color: colour,
        dataset: {
          source: this.segmentData
        },
        series: [
          {
            name: '主营占比',
            type: 'pie',
            radius: ['50%', '100%'],
            encode: {
              name: 'name',
              value: 'incomeRatio'
            },
            label: {
              show: false
            },
            emphasis: {
              disabled: true
            }
          }
        ]
      }
    },
    options() {
      return [
        [
          { label: '按业务', class: '!px14py4', value: this.market === 'hs' ? 1100 : 'B' },
          { label: '按地区', class: '!px14py4', value: this.market === 'hs' ? 1200 : 'G' }
        ]
      ]
    }
  },
  watch: {
    activedTab() {
      this.getSegment()
    }
  },
  mounted() {
    if (this.market === 'hs') {
      this.activedTab = 1100
    } else {
      this.getSegment()
    }
  },
  methods: {
    postcssPatch,
    getColor(index) {
      return colour[index] ?? '#009E56'
    },
    async getSegment() {
      const res = await this.$post(this.$api.f10[this.market] + '/finance/segment', {
        symbol: this.symbol,
        segmentType: this.activedTab
      })
      const data =
        res.data?.sort((a, b) => {
          return b.incomeRatio - a.incomeRatio
        }) ?? []

      this.segmentData = data.map((item) => {
        return {
          name: item.name,
          incomeRatio: item.incomeRatio,
          operatingIncome: item.operatingIncome,
          reportDate: item.reportDate,
          currency: item.currency
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.main-business-composition {
  padding: 0 var(--edge-padding) var(--edge-padding);
  background: var(--bg-color-2);
  .rk-switch {
    padding-top: var(--edge-padding);
  }
  .echarts-container {
    margin: 15px 0;
  }
  .legend-item {
    display: flex;
    align-items: center;
  }
  .legend-icon {
    flex-shrink: 0;
    margin-right: 5px;
    width: 10px;
    height: 10px;
  }
}

.business-table {
  --table-thead-cell-padding: 12px 4px;
  --table-tbody-cell-padding: 5px 4px;
  --table-tbody-font-size: 14px;
}
</style>
